import React from "react";
import { ReferEarn } from "@/components/ReferEarn";

export default function Refer() {
  return (
    <div className="mx-auto max-w-xl space-y-6" data-testid="refer-page">
      <div>
        <h1 className="font-display text-3xl font-semibold tracking-tight sm:text-4xl">Refer &amp; Earn</h1>
        <p className="mt-2 text-muted-foreground">Grow your credit for free — invite friends and earn when they make their first top-up.</p>
      </div>
      <ReferEarn />
    </div>
  );
}
